/**
 * 使用画像指示画面インプットVOクラス
 *
 * @export KYMW1407InputModel
 * @class KYMW1407InputModel
 */
export class KYMW1407InputModel {

  // 受注コード
  public orderCode: string = null;
  // 生協コード
  public coopCode: string = null;
  // コマID
  public komaId: string = null;
  // 編集モード
  public editMode: boolean = null;
  // 商品件数
  public goodsCount = Number(0);
}
